import { Component } from '@angular/core';

@Component({
  selector: 'app-content-carousel',
  templateUrl: './content-carousel.component.html',
  styleUrls: ['./content-carousel.component.scss'],
})
export class ContentCarouselComponent {
  public scrolling(event, el) {
    const scrollElement = el.nativeElement.querySelector('div.ng-native-scrollbar-hider');
    scrollElement.scrollLeft = scrollElement.scrollLeft + event.deltaY;
  }
}
